module.exports = __webpack_public_path__ + "static/media/Inter-Bold.2767206d.woff";